import { Col, Row, Image, Typography, Divider } from 'antd'
import React from 'react'

const { Title, Paragraph } = Typography;

export default function Acknowledgement() {

    const ThanksImages = [
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image1.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image2.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image3.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image4.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image5.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image6.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image7.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image8.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image9.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image10.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image11.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image12.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image13.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image14.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image15.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image16.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image17.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image18.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image19.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image20.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image21.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image22.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image23.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image24.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image25.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image26.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image27.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image28.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image29.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image30.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image31.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image32.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image33.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image34.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image35.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image36.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image37.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image38.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image39.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image40.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image41.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image42.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image43.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image44.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image46.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image47.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image48.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image49.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image50.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image51.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image52.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image53.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image54.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image55.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image56.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image57.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image58.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image59.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image60.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image61.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image62.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image63.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image64.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image65.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image66.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image67.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image68.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image69.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image70.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image71.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image73.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image74.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image75.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image76.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image77.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image78.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image79.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image80.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image81.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image82.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image83.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image84.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image86.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image87.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image88.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image89.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image90.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image91.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/media/image92.png"
    ];

    const ThanksImages2 = [
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image29.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image62.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image63.jpeg",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image65.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image66.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image67.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image68.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image69.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image70.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image72.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image73.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image5.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image6.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image7.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image8.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image9.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image10.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image13.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image14.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image15.png",
        "https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image16.png",
    ];

    // Optimized image parameters for faster loading and better quality
    // resize: m_lfit, w_200 (limit to 200px width)
    // quality: q_75 (balanced quality)
    // format: webp (modern high-compression format)
    const ImageFooter = "?x-oss-process=image/resize,m_lfit,w_200/quality,q_75/format,webp"

    const allLogos = [...ThanksImages, ...ThanksImages2];

    // Funding 图片单独维护，后续如果 OSS 资源替换，只需要调整这里的地址
    const fundingImages = [
        {
            src: 'https://gsrd-server.tos-cn-beijing.volces.com/guoziran.png',
            title: 'Funding 1',
            maxWidth: '520px',
            scale: 1.24,
        },
        {
            src: 'https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image119.png',
            title: 'Funding 2',
            maxWidth: '560px',
            scale: 0.65,
        },
    ];

    const logoItemStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        transition: 'all 0.3s ease',
        cursor: 'default',
    };

    return (
        <div className="shared-hero-page" style={{ backgroundColor: '#fdfdfd', minHeight: '100vh', paddingBottom: '60px' }}>
            {/* Hero Section */}
            <div className="shared-hero-banner" style={{
                padding: '80px 20px 60px',
                textAlign: 'center',
                color: 'white',
                marginBottom: '40px'
            }}>
                <Title level={1} style={{ color: 'white', fontSize: '3rem', fontWeight: 800, marginBottom: '20px' }}>
                    Acknowledgements
                </Title>
            </div>

            <Row justify={'center'}>
                <Col xs={22} sm={20} md={18}>
                    <div style={{ marginBottom: '52px' }}>
                        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
                            <Title level={2} style={{ color: '#055878', fontWeight: 760, marginBottom: 0 }}>
                                Funding
                            </Title>
                            <Divider style={{ borderColor: '#055878', opacity: 0.2, width: '60px', minWidth: '60px', margin: '18px auto 0' }} />
                        </div>

                        <div
                            style={{
                                padding: '28px',
                                border: '1px solid rgba(8,95,120,0.12)',
                                borderRadius: '20px',
                                background: '#ffffff',
                                boxShadow: '0 18px 44px rgba(6,61,85,0.08)',
                            }}
                        >
                            <Row gutter={[24, 24]} align="middle" justify="center">
                                {fundingImages.map((item) => (
                                    <Col key={item.src} xs={24} md={12}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                minHeight: '216px',
                                                padding: '26px 30px',
                                                overflow: 'hidden',
                                                border: '1px solid rgba(8,95,120,0.10)',
                                                borderRadius: '16px',
                                                background: 'linear-gradient(180deg, #f8fcfd 0%, #ffffff 100%)',
                                            }}
                                        >
                                            <Image
                                                src={item.src}
                                                alt={item.title}
                                                preview={false}
                                                style={{
                                                    width: '100%',
                                                    maxWidth: item.maxWidth,
                                                    maxHeight: '190px',
                                                    objectFit: 'contain',
                                                    display: 'block',
                                                    transform: `scale(${item.scale})`,
                                                    transformOrigin: 'center',
                                                }}
                                            />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>

                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <Title level={2} style={{ color: '#055878', fontWeight: 700 }}>
                            Collaborating Organizations
                        </Title>
                        <Divider style={{ borderColor: '#055878', opacity: 0.2, width: '60px', minWidth: '60px', margin: '20px auto' }} />
                    </div>

                    <Row gutter={[16, 16]} justify="center">
                        {allLogos.map((item, index) => (
                            <Col 
                                key={index} 
                                xs={8}    // 3 per row on mobile
                                sm={6}    // 4 per row on small tablets
                                md={4}    // 6 per row on medium screens
                                lg={3}    // 8 per row on large screens
                            >
                                <div 
                                    className="logo-container"
                                    style={{
                                        ...logoItemStyle,
                                        backgroundColor: 'white',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                        height: '100px',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
                                    }}
                                >
                                    <Image
                                        width="100%"
                                        height="100%"
                                        src={item + ImageFooter}
                                        preview={false}
                                        style={{ 
                                            objectFit: 'contain',
                                            padding: '5px' 
                                        }}
                                        placeholder={
                                            <div style={{ width: '100%', height: '100%', backgroundColor: '#f0f0f0', borderRadius: '8px' }} />
                                        }
                                    />
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            {/* CSS for custom transitions if needed, but using JS inline for simplicity in this project's style */}
        </div>
    )
}
